import { CHATS } from '../actions/chats';

const defaultState = {
  page: 1,
  itemsPerPage: 12,
  list: [],
  count: 0,
  isLoaded: false,
};

export default (state = defaultState, { type, ...action }) => {
  switch (type) {
    // case CHATS.LOAD:
    //   return { ...state, list: [], isLoaded: false };

    case CHATS.LOAD_DONE:
      return {
        ...state,
        page: action.page,
        list: action.list,
        count: action.count,
        isLoaded: true,
      };

    case CHATS.LOAD_FAILED:
      console.log(action.message);
      return { ...state, list: [], isLoaded: true };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/chats.js